import { twMerge } from 'tailwind-merge';
import { input } from '../../patterns/input';
import { ComponentProps } from 'react';
import { TextArea as AriaTextArea } from 'react-aria-components';

type Props = {
  className?: string;
} & Omit<ComponentProps<typeof AriaTextArea>, 'className'>;

export function TextArea(props: Props) {
  const { className, ...rest } = props;

  return (
    <AriaTextArea
      className={twMerge(input(), 'min-h-[8em]', className)}
      {...rest}
    />
  );
}
